/**
 * Transforms number X to string Xpx for usage on canvas
 * @param size
 * @returns
 */
export function toPx(size: number): string {
  return `${size}px`
}
